<template>
  <a
    class="wdw-social-sharing-link"
    @click="showSocialSharing"
    :class="{ isActive: extraStyling }"
    @keyup.enter="showSocialSharing"
    tabindex="0"
    role="link"
  >
    <font-awesome-icon :icon="['fas', 'up-right-from-square']" title="durch Soziale Medien teilen" />
  </a>
  <OverlayPanel
    ref="socialOverlayPanel"
    :showCloseIcon="true"
    :dismissable="true"
    appendTo="body"
    class="social-sharing wdw-widgets"
  >
    <ShareNetwork network="facebook" :url="url" :title="title" :description="description" :qoute="description">
      <font-awesome-icon :icon="['fab', 'facebook-f']" aria-hidden="true" />
      <span class="visually-hidden">Auf Facebook teilen</span>
    </ShareNetwork>
    <ShareNetwork network="twitter" :url="url" :title="title" :description="description">
      <font-awesome-icon :icon="['fab', 'x-twitter']" aria-hidden="true" />
      <span class="visually-hidden">Auf Twitter teilen</span>
    </ShareNetwork>
    <ShareNetwork network="whatsapp" :url="url" :title="title" :description="description">
      <font-awesome-icon :icon="['fab', 'whatsapp']" aria-hidden="true" />
      <span class="visually-hidden">Auf WhatsApp teilen</span>
    </ShareNetwork>
    <ShareNetwork network="email" :url="url" :title="title" :description="description">
      <font-awesome-icon :icon="['fas', 'envelope']" aria-hidden="true" />
      <span class="visually-hidden">Per Email teilen</span>
    </ShareNetwork>
  </OverlayPanel>
</template>

<script>
import { ref, toRef } from 'vue';
import OverlayPanel from 'primevue/overlaypanel';
export default {
  name: 'WdwSocialSharing',
  components: {
    OverlayPanel,
  },
  props: {
    url: { type: String, required: true },
    title: { type: String, required: false },
    description: { type: String, required: true },
    singleView: { type: Boolean, required: false, default: false },
  },
  setup(props) {
    //---Variables---
    const socialOverlayPanel = ref();
    const extraStyling = toRef(props, 'singleView');
    //---Methods---
    function showSocialSharing(event) {
      //Prevents Showing the detailed Topic when clicking on "TEILEN" when in the ListWrapper.
      event.stopPropagation();
      socialOverlayPanel.value.show(event);
    }

    return {
      socialOverlayPanel,
      extraStyling,
      showSocialSharing,
    };
  },
};
</script>

<style lang="scss" scoped>
.svg-inline--fa {
  height: 20px;
  width: 3em;
  &.fa-share {
    font-size: 0.5rem;
    margin-top: -3px; //move up slightly
  }
}
a:not(.btn):hover,
a:not(.btn):active,
a:not(.btn):focus {
  text-decoration: none;
}
a:not(.btn).wdw-social-sharing-link {
  color: var(--wdw-social-share-title-color, #6c757d);
  z-index: 99;
  &:hover {
    color: var(--wdw-social-share-title-hover-color, darken(#6c757d, 15%));
  }
}

.isActive {
  margin: 25px 25px;
}

.svg-inline--fa.icon-border {
  border-top: 5px;
  background-color: #fff;
  color: #6b7881;
  border-radius: 2px 2px 2px 2px;
  &:hover {
    color: var(--wdw-social-share-title-hover-color, darken(#6c757d, 10%));
  }
}
</style>
